module.exports = __webpack_public_path__ + "static/media/blog.aba4237e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/blog.jpg
// module id = 729
// module chunks = 0 1 10 11